import { useEffect } from "react";
import Loader from "../Loader";

const CONFIG = {
  name: "Barbera",
  scheme: "barbera://",
  iosStore: "https://apps.apple.com/in/app/barbera/id6740431000",
  androidStore:
    "https://play.google.com/store/apps/details?id=com.barbera.barberaconsumerapp",
    iosAppId: "6740431000",
};

export default function DeepLinkPage() {
  useEffect(() => {
    let fallbackTimer = null;
    let appOpened = false;

    const ua = navigator.userAgent;
    const isiOS = /iPhone|iPad|iPod/.test(ua);
    const isAndroid = /android/i.test(ua);
    const isDesktop = !isiOS && !isAndroid;

    const path = window.location.pathname.replace("/dl", "");
    const query = window.location.search;

    const deepLink = `${CONFIG.scheme}${path}${query}`;
    const deferredData = `${path}${query}`;

    function buildStoreUrl() {
      if (isAndroid) {
        const sep = CONFIG.androidStore.includes("?") ? "&" : "?";
       return `intent://details?id=com.barbera.barberaconsumerapp#Intent;scheme=market;package=com.android.vending;end`;
      }
      return CONFIG.iosStore;
    }

    const storeUrl = buildStoreUrl();

    async function copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
      } catch {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
    }

    function markAppOpened() {
      appOpened = true;
      if (fallbackTimer) clearTimeout(fallbackTimer);
    }

    if (isDesktop) return;

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) markAppOpened();
    });

    window.addEventListener("pagehide", markAppOpened);

    fallbackTimer = setTimeout(async () => {
      if (appOpened || document.hidden) return;

      if (isiOS) {
        await copyToClipboard(deepLink);
      }

      window.location.href = storeUrl;
    }, 1200);

    window.location.href = deepLink;
  }, []);

  return (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      textAlign: "center",
      flexDirection: "column",
      padding: "20px",
    }}
  >
    {/* Loader */}
    <div
      style={{
        width: "32px",
        height: "32px",
        border: "4px solid #f3f3f3",
        borderTop: "4px solid #000",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        marginBottom: "20px",
      }}
    />

    <h2 style={{ marginBottom: "10px" }}>Opening Barbera...</h2>

    <p style={{ color: "#666" }}>
      If not redirected, please wait...
    </p>

    {/* Inline keyframes */}
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);
}